<template>
      <v-select
        hide-details 
        append-icon="search"
        :label="$t('Main-Type')"
        :loading="loading"
        :items="items"
        item-text="Aciklama"
        cache-items=""
        item-value="Kod"
        :clearable="clearable"
        v-model="Kod"

      ></v-select>
</template>

<script>

export default {
    props: {
      value: {},
      // Secimi geri alabilmek icin, YALNIZCA filtre ekranlarinda. Varsayilan false:
      // bileseni veri girisi icin kullanan ekranlarin (rezervasyon, mice, rezervasyon/index)
      // davranisi degismez, oralarda alan bos birakilamamaya devam eder.
      // Disaridan <anatip clearable> yazmak yetmiyordu: bilesen $attrs'i v-select'e
      // forward etmedigi icin Vue 2'de attribute kok DOM elemanina ham olarak dusuyordu.
      clearable: { type: Boolean, default: false },
    },
      
    computed: {
      Kod: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue )
        },
      },
    },
  
    
    data () {
      return {
        loading: false,
        items: [
            {Kod:1, Aciklama: this.$t('Domestic-Tour')},
            {Kod:2, Aciklama: this.$t('Incoming')},
            {Kod:3, Aciklama: this.$t('Outgoing')},
            {Kod:4, Aciklama: this.$t('Meeting-Seminar')},
            {Kod:5, Aciklama: this.$t('Ship')},
            {Kod:6, Aciklama: this.$t('Other-Services')},
            {Kod:7, Aciklama: this.$t('Domestic-v2')},
            {Kod:8, Aciklama: this.$t('Abroad')},
            {Kod:9, Aciklama: this.$t('Cyprus')},
            {Kod:10, Aciklama: this.$t('Activity')},
            {Kod:11, Aciklama: this.$t('Land-Tours') },
            {Kod:12, Aciklama: 'MICE' },
            {Kod:13, Aciklama: 'Vize' },
            
        ],
      }
    },
  
  watch: {
    
  },
  methods: {

  }
}


</script>